import { Box, Container, Link, Stack, Typography } from "@mui/material";
import React from "react";

import { ArrowForward } from "@mui/icons-material";
import COLORS from "../../../constants/colors";
import SplitContentBlock from "../../SplitContentBlock";
import HordeCoins from "../../../assets/svgs/hordeCoins.svg";
import useIsMobile from "../../../hooks/useIsMobile";

const AbstractHordeFondet = () => {
  const isMobile = useIsMobile();
  return (
    <Box bgcolor={COLORS.BRIGHT_BLUE[60]}>
      <Container>
        <Stack component="section">
          <SplitContentBlock
            direction={isMobile ? "column-reverse" : "row-reverse"}
            gap={isMobile ? "4px" : "0px"}
          >
            <Stack
              gap="32px"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Typography
                variant="h2"
                color={COLORS.BLACK[100]}
                maxWidth="500px"
              >
                10 millioner grunner til å bli sjef i egen økonomi
              </Typography>
              <Typography
                variant="body"
                color={COLORS.BLACK[100]}
                maxWidth="430px"
              >
                Det lønner seg å ha Horde-appen. Vi har opprettet et Horde-fond
                på 10 millioner. Hver eneste krone skal brukes på brukerne våre,
                blant annet gjennom gjeldsnedbetalinger.
              </Typography>

              <Link
                href="https://horde.no/gjeldfri/horde-fondet"
                color="primary"
                fontWeight="bold"
                rel="noreferrer"
                target="_blank"
              >
                Mer om Horde-fondet <ArrowForward />
              </Link>
            </Stack>

            <Stack>
              <HordeCoins width="100%" />
            </Stack>
          </SplitContentBlock>
        </Stack>
      </Container>
    </Box>
  );
};

/**
 * Render a section with a brief abstract and link about Horde
 * as a company. In mobile view this will render as a white card section
 * */
const HordeFondetAbstract = () => {
  return (
    <Container
      component="section"
      sx={{ paddingY: { md: "80px", xs: "48px" } }}
    >
      <AbstractHordeFondet />
    </Container>
  );
};
export default HordeFondetAbstract;
